var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDateString, IsEnum, IsInt, IsObject, IsOptional, IsString, Max, Min, ValidateNested } from "class-validator";
export const REPORT_SCHEDULE_TIME_ZONE = "America/Los_Angeles";
export function formatInReportTimeZone(iso) {
    return new Intl.DateTimeFormat("en-US", {
        timeZone: REPORT_SCHEDULE_TIME_ZONE,
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
    }).format(new Date(iso));
}
export var ReportType;
(function (ReportType) {
    ReportType["TEFCA_LOCATIONS"] = "TEFCA_LOCATIONS";
    ReportType["FASTEN_LOCATIONS"] = "FASTEN_LOCATIONS";
})(ReportType || (ReportType = {}));
export var ReportSource;
(function (ReportSource) {
    ReportSource["SQL"] = "SQL";
    ReportSource["API"] = "API";
    ReportSource["ETL"] = "ETL";
})(ReportSource || (ReportSource = {}));
export var ReportFormat;
(function (ReportFormat) {
    ReportFormat["CSV"] = "CSV";
    ReportFormat["JSON"] = "JSON";
})(ReportFormat || (ReportFormat = {}));
export var ReportDataClassification;
(function (ReportDataClassification) {
    ReportDataClassification["NONE"] = "NONE";
    ReportDataClassification["INTERNAL"] = "INTERNAL";
    ReportDataClassification["PII"] = "PII";
    ReportDataClassification["PHI"] = "PHI";
})(ReportDataClassification || (ReportDataClassification = {}));
export var ReportRunStatus;
(function (ReportRunStatus) {
    ReportRunStatus["QUEUED"] = "QUEUED";
    ReportRunStatus["RUNNING"] = "RUNNING";
    ReportRunStatus["SUCCEEDED"] = "SUCCEEDED";
    ReportRunStatus["FAILED"] = "FAILED";
    ReportRunStatus["EXPIRED"] = "EXPIRED";
})(ReportRunStatus || (ReportRunStatus = {}));
export var ReportRunTrigger;
(function (ReportRunTrigger) {
    ReportRunTrigger["ON_DEMAND"] = "ON_DEMAND";
    ReportRunTrigger["SCHEDULED"] = "SCHEDULED";
})(ReportRunTrigger || (ReportRunTrigger = {}));
export var ReportScheduleWindow;
(function (ReportScheduleWindow) {
    ReportScheduleWindow["PREVIOUS_DAY"] = "PREVIOUS_DAY";
    ReportScheduleWindow["PREVIOUS_WEEK"] = "PREVIOUS_WEEK";
    ReportScheduleWindow["PREVIOUS_MONTH"] = "PREVIOUS_MONTH";
    ReportScheduleWindow["LAST_7_DAYS"] = "LAST_7_DAYS";
    ReportScheduleWindow["LAST_30_DAYS"] = "LAST_30_DAYS";
    ReportScheduleWindow["LAST_90_DAYS"] = "LAST_90_DAYS";
})(ReportScheduleWindow || (ReportScheduleWindow = {}));
export var ReportScheduleSource;
(function (ReportScheduleSource) {
    ReportScheduleSource["DEFINITION"] = "DEFINITION";
    ReportScheduleSource["OVERRIDE"] = "OVERRIDE";
})(ReportScheduleSource || (ReportScheduleSource = {}));
export class ReportScheduleDto {
}
__decorate([
    IsString()
], ReportScheduleDto.prototype, "cron", void 0);
__decorate([
    IsBoolean()
], ReportScheduleDto.prototype, "enabled", void 0);
__decorate([
    IsEnum(ReportScheduleSource)
], ReportScheduleDto.prototype, "source", void 0);
__decorate([
    IsOptional(),
    IsEnum(ReportScheduleWindow)
], ReportScheduleDto.prototype, "window", void 0);
__decorate([
    IsOptional(),
    IsDateString()
], ReportScheduleDto.prototype, "nextRunAt", void 0);
__decorate([
    IsInt()
], ReportScheduleDto.prototype, "consecutiveFailures", void 0);
__decorate([
    IsOptional(),
    IsString()
], ReportScheduleDto.prototype, "disabledReason", void 0);
__decorate([
    IsOptional(),
    IsString()
], ReportScheduleDto.prototype, "updatedByName", void 0);
__decorate([
    IsOptional(),
    IsDateString()
], ReportScheduleDto.prototype, "updatedAt", void 0);
export class ReportScheduleInput {
}
__decorate([
    IsString()
], ReportScheduleInput.prototype, "cron", void 0);
__decorate([
    IsBoolean()
], ReportScheduleInput.prototype, "enabled", void 0);
export class ReportRunRequestInput {
}
__decorate([
    IsOptional(),
    IsObject()
], ReportRunRequestInput.prototype, "params", void 0);
export class ReportRunListQuery {
}
__decorate([
    IsOptional(),
    IsEnum(ReportType)
], ReportRunListQuery.prototype, "reportType", void 0);
__decorate([
    IsOptional(),
    IsEnum(ReportRunStatus)
], ReportRunListQuery.prototype, "status", void 0);
__decorate([
    IsOptional(),
    Type(() => Number),
    IsInt(),
    Min(1),
    Max(200)
], ReportRunListQuery.prototype, "limit", void 0);
__decorate([
    IsOptional(),
    IsDateString()
], ReportRunListQuery.prototype, "before", void 0);
export var ReportParamType;
(function (ReportParamType) {
    ReportParamType["DATE"] = "DATE";
    ReportParamType["STRING"] = "STRING";
    ReportParamType["NUMBER"] = "NUMBER";
    ReportParamType["BOOLEAN"] = "BOOLEAN";
})(ReportParamType || (ReportParamType = {}));
export class ReportParamDto {
}
__decorate([
    IsString()
], ReportParamDto.prototype, "name", void 0);
__decorate([
    IsEnum(ReportParamType)
], ReportParamDto.prototype, "type", void 0);
__decorate([
    IsBoolean()
], ReportParamDto.prototype, "required", void 0);
export class ReportDefinitionDto {
}
__decorate([
    IsEnum(ReportType)
], ReportDefinitionDto.prototype, "type", void 0);
__decorate([
    IsString()
], ReportDefinitionDto.prototype, "title", void 0);
__decorate([
    IsString()
], ReportDefinitionDto.prototype, "description", void 0);
__decorate([
    IsEnum(ReportSource)
], ReportDefinitionDto.prototype, "source", void 0);
__decorate([
    IsEnum(ReportFormat)
], ReportDefinitionDto.prototype, "format", void 0);
__decorate([
    IsEnum(ReportDataClassification)
], ReportDefinitionDto.prototype, "classification", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => ReportParamDto)
], ReportDefinitionDto.prototype, "params", void 0);
__decorate([
    IsOptional(),
    IsString()
], ReportDefinitionDto.prototype, "defaultSchedule", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => ReportScheduleDto)
], ReportDefinitionDto.prototype, "schedule", void 0);
export class ReportRunDto {
}
__decorate([
    IsString()
], ReportRunDto.prototype, "id", void 0);
__decorate([
    IsString()
], ReportRunDto.prototype, "reportType", void 0);
__decorate([
    IsEnum(ReportRunStatus)
], ReportRunDto.prototype, "status", void 0);
__decorate([
    IsEnum(ReportRunTrigger)
], ReportRunDto.prototype, "trigger", void 0);
__decorate([
    IsEnum(ReportFormat)
], ReportRunDto.prototype, "format", void 0);
__decorate([
    IsOptional(),
    IsObject()
], ReportRunDto.prototype, "params", void 0);
__decorate([
    IsOptional(),
    IsInt()
], ReportRunDto.prototype, "rowCount", void 0);
__decorate([
    IsOptional(),
    IsInt()
], ReportRunDto.prototype, "fileSizeBytes", void 0);
__decorate([
    IsOptional(),
    IsDateString()
], ReportRunDto.prototype, "dataAsOf", void 0);
__decorate([
    IsOptional(),
    IsString()
], ReportRunDto.prototype, "error", void 0);
__decorate([
    IsOptional(),
    IsString()
], ReportRunDto.prototype, "requestedByUserId", void 0);
__decorate([
    IsOptional(),
    IsString()
], ReportRunDto.prototype, "requestedByName", void 0);
__decorate([
    IsOptional(),
    IsDateString()
], ReportRunDto.prototype, "startedAt", void 0);
__decorate([
    IsOptional(),
    IsDateString()
], ReportRunDto.prototype, "finishedAt", void 0);
__decorate([
    IsOptional(),
    IsInt()
], ReportRunDto.prototype, "durationMs", void 0);
__decorate([
    IsDateString()
], ReportRunDto.prototype, "createdAt", void 0);
__decorate([
    IsBoolean()
], ReportRunDto.prototype, "downloadable", void 0);
export class ReportRunListDto {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => ReportRunDto)
], ReportRunListDto.prototype, "runs", void 0);
__decorate([
    IsOptional(),
    IsDateString()
], ReportRunListDto.prototype, "nextBefore", void 0);
export class ReportRunQueuedDto {
}
__decorate([
    IsString()
], ReportRunQueuedDto.prototype, "runId", void 0);
__decorate([
    IsEnum(ReportRunStatus)
], ReportRunQueuedDto.prototype, "status", void 0);
export class ReportDownloadDto {
}
__decorate([
    IsString()
], ReportDownloadDto.prototype, "url", void 0);
__decorate([
    IsString()
], ReportDownloadDto.prototype, "filename", void 0);
__decorate([
    IsDateString()
], ReportDownloadDto.prototype, "expiresAt", void 0);
